$( document ).ready(function() {
    $.get("https://freegeoip.app/json/", function (response) {
        var country_code = response.country_code;
        if(country_code != 'AU' && country_code !='GB' && country_code !='CA'){
            $('.payment-buttons').hide();
          	$('.payment-buttons').after('<a href="https://www.timebicycles.com/a/store-locator/list" class="btn btn--full">Find a distributor</a>');
        }
    }, "jsonp");
});
